import { useMutation } from 'react-query';
import { createCompanyShareToken } from './queryFn';
import { addSnackBar } from '@/components/SnackBar/redux';
import { useDispatch } from 'react-redux';

export const useCreateCompanyShareToken = () => {
  const dispatch = useDispatch();
  const { mutate, status } = useMutation(createCompanyShareToken, {
    onError: () => {
      dispatch(
        addSnackBar.trigger({
          type: 'bad',
          message:
            'Maximum number of share links per month reached. Please contact support',
          lifeTime: 4000,
        })
      );
    },
  });
  return { mutate, status };
};
